import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyStateNotifications = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: 28,
	height: 34,
	viewBox: "0 0 28 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M8.4651 11.936C10.2725 11.7788 11.7478 10.425 12.0592 8.63768L13.5063 0.333374L14.9493 8.61504C15.2626 10.4129 16.753 11.7707 18.5721 11.9157L27.3334 12.6141L18.5721 13.3124C16.753 13.4574 15.2626 14.8153 14.9493 16.6131L13.5063 24.8948L12.0592 16.5905C11.7478 14.8032 10.2725 13.4493 8.4651 13.2922L0.666748 12.6141L8.4651 11.936Z",
	fill: "#D3D2D9"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M17.932 23.0225C19.746 22.8535 21.2166 21.4801 21.5091 19.6818L21.8026 17.8772L22.0921 19.6575C22.3864 21.467 23.8732 22.8449 25.6998 23.0008L27.3334 23.1404L25.6998 23.2799C23.8732 23.4359 22.3864 24.8137 22.0921 26.6233L21.8026 28.4035L21.5091 26.5989C21.2166 24.8007 19.746 23.4272 17.932 23.2582L16.6667 23.1404L17.932 23.0225Z",
	fill: "#D3D2D9"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M13.1111 31.0351C14.3906 30.9159 15.4279 29.9472 15.6342 28.6788L15.679 28.4036L15.6922 28.4846C15.9167 29.865 17.0509 30.9161 18.4444 31.0351C17.0509 31.1541 15.9167 32.2053 15.6922 33.5857L15.679 33.6667L15.6342 33.3915C15.4279 32.1231 14.3906 31.1543 13.1111 31.0351Z",
	fill: "#D3D2D9"
}));
const ForwardRef = forwardRef(SvgEmptyStateNotifications);
export default ForwardRef;
